<template>
  <main class="main page-inside products-page">
    <div class="main-wrapper">
      <div class="section shop-section">
        <div class="wrapper">
          <div class="topbar">
            <div class="title title-main shop-title">
              <img src="../img/Polygon2.svg" class="shop-arrow-left" />
              <img src="../img/Polygonhead.svg" class="shop-arrow-left" />
              SHOP
              <img src="../img/Polygonhead.svg" class="shop-arrow-right" />
              <img src="../img/Polygon2.svg" class="shop-arrow-right" />
            </div>
            <div class="search">
              <input
                type="text"
                placeholder="Search"
                v-model="searchedProductText"
                @keyup.enter="searchSubmit"
              />
              <a class="glass" @click="searchSubmit">
                <img src="../img/glass.svg" class="img" />
              </a>
            </div>
            <div class="sort">
              <div class="select-container" v-if="sortOptions.length">
                <Select2
                  class="select2 single"
                  v-model="sort"
                  :options="sortOptions"
                  placeholder="Sort by cheapest"
                  @select="selectSort($event)"
                />
              </div>
            </div>
          </div>
          <div class="shop-main">
            <div class="filters">
              <div class="title">FILTERS</div>
              <div class="filters-price">
                <div class="desc">
                  <b>PRICE:</b>
                </div>
                <div class="val-container">
                  <div class="val min">
                    <input
                      v-model="barMinValue"
                      type="number"
                      placeholder="min"
                    />
                    <div class="desc cur">
                      {{ $parent.currency }}
                    </div>
                  </div>
                  <div class="desc">-</div>
                  <div class="val max">
                    <input
                      v-model="barMaxValue"
                      type="number"
                      placeholder="max"
                    />
                    <div class="desc cur">
                      {{ $parent.currency }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="filters-item" v-if="categories && categories.length">
                <div class="desc">
                  <b>TYPE:</b>
                </div>
                <div class="select-container">
                  <label
                    class="chekbox-label"
                    v-for="(item, i) in categories"
                    :key="i"
                  >
                    <div class="chekbox-label-wrapper">
                      <input
                        type="checkbox"
                        v-model="activeCategory"
                        :value="item"
                        @input="checkActiveCategory"
                      />
                      <div class="checkbox"></div>
                      <span class="desc">
                        {{ item.text }}
                      </span>
                    </div>
                  </label>
                </div>
                <a class="desc link reset-filters-link" @click="reset()">
                  Reset filters
                </a>
              </div>
            </div>
            <transition name="fade">
              <div
                class="product-list"
                v-if="productList.data && productList.data.length"
              >
                <div
                  class="item"
                  v-for="item in productList.data"
                  :key="item.id"
                  @click="openProductModal(item)"
                >
                  <div class="product-img-wrapper">
                    <img :src="imgDomain + item.img + '.png'" class="img" />
                    <img src="../img/Polygon.svg" class="polygon-overlay" />
                  </div>
                  <div class="category" v-if="getCategoryName(item)">{{ getCategoryName(item) }}</div>
                  <span class="name desc big">{{ item.name }}</span>
                  <div class="bottom">
                    <div class="price-container">
                      <div class="price-left">
                        <div class="price old-price">
                          <span class="title medium">
                            {{ item.old_price.toFixed(2) }}</span
                          >
                          <img src="../img/coin.svg" class="coin" />
                        </div>
                        <span class="price">
                          <span class="title medium amount">{{
                            item.price.toFixed(2)
                          }}</span>
                          <img src="../img/coin.svg" class="coin" />
                        </span>
                      </div>
                      <div class="price-right">
                        <img src="../img/card.svg" class="card-icon" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </transition>
            <transition name="fade">
              <div
                class="title no-products"
                v-if="productList.data && !productList.data.length"
              >
                <b>No products</b>
              </div>
            </transition>
          </div>
          <div class="pagination-wrapper">
            <pagination
              v-if="totalProducts"
              v-model="activePage"
              :per-page="9"
              :records="totalProducts"
              @paginate="changePage"
            />
          </div>
        </div>
      </div>
    </div>
    <footer class="new-footer">
      <div class="footer-top">
        <div class="wrapper">
          <div class="footer-links">
            <a 
              v-for="page in footerPages" 
              :key="page.id"
              @click="$parent.goToPage(page)" 
              class="footer-link"
            >
              {{ page.title.toUpperCase() }}
            </a>
          </div>
        </div>
      </div>
      <div class="footer-middle">
        <div class="wrapper">
          <div class="footer-column footer-column-left">
            <div class="footer-info">
              <div class="footer-info" v-if="$parent.settings">
                <div class="footer-info-item" v-if="$parent.settings.company_name"><span class="footer-info-label">COMPANY NAME:</span> {{ $parent.settings.company_name }}</div>
                <div class="footer-info-item" v-if="$parent.settings.company_reg_number"><span class="footer-info-label">REGISTRATION NUMBER:</span> {{ $parent.settings.company_reg_number }}</div>
                <div class="footer-info-item" v-if="$parent.settings.company_address"><span class="footer-info-label">ADDRESS:</span> {{ $parent.settings.company_address }}</div>
              </div>
            </div>
          </div>
          <div class="footer-column footer-column-center">
            <router-link to="/" class="footer-logo">
              <img src="../img/footer logo.svg" class="footer-logo-img" />
            </router-link>
          </div>
          <div class="footer-column footer-column-right">
            <div class="footer-support">
              <div class="footer-support-email" v-if="$parent.settings && $parent.settings.support_email">SUPPORT: {{ $parent.settings.support_email }}</div>
              <div class="footer-social-icons">
                <a
                  v-for="link in $parent.socials"
                  :key="link.image"
                  :href="link.link"
                  target="_blank"
                  class="footer-social-icon"
                >
                  <img 
                    :src="getSocialIcon(link.link)" 
                    :alt="link.link" 
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="wrapper">
          <div class="footer-copyright" v-if="$parent.settings && $parent.settings.copyright">
            {{ $parent.settings.copyright }}
          </div>
          <div class="footer-payment-methods">
            <img src="../img/Mastercard.svg" class="payment-icon" alt="Mastercard" />
            <img src="../img/visa-pay.svg" class="payment-icon" alt="Visa" />
            <img src="../img/apple-pay.svg" class="payment-icon" alt="Apple Pay" />
            <img src="../img/google-pay.svg" class="payment-icon" alt="Google Pay" />
          </div>
        </div>
      </div>
    </footer>
  </main>
</template>
<script>
import Pagination from "vue-pagination-2";
import Select2 from "vue3-select2-component";
import axios from '@/axios';
import acebookIcon from '../img/acebook.svg';
import instagramIcon from '../img/instagram.svg';
import steamIcon from '../img/steam.svg';

export default {
  name: "Products",
  props: ["currency", "currencyCode"],
  components: {
    Pagination,
    Select2,
  },
  data: function () {
    return {
      acebookIcon: acebookIcon,
      instagramIcon: instagramIcon,
      steamIcon: steamIcon,
      imgDomain: "",
      productList: [],
      activePage: 1,
      totalProducts: null,
      searchedProductText: "",
      activeCategory: [{ id: 0, text: "All" }],
      sort: "price",
      categories: [],
      sortOptions: [
        {
          id: "price",
          text: "Sort by cheapest",
        },
        {
          id: "-price",
          text: "Sort by expensive",
        },
      ],
      barMinValue: 0,
      barMaxValue: 1200,
    };
  },
  computed: {
    footerPages() {
      if (!this.$parent.textPageList || !Array.isArray(this.$parent.textPageList)) {
        return [];
      }
      const keywords = ['terms', 'privacy', 'cookie'];
      return keywords
        .map(keyword => {
          return this.$parent.textPageList.find(page => 
            page.slug && page.slug.toLowerCase().includes(keyword) ||
            page.title && page.title.toLowerCase().includes(keyword)
          );
        })
        .filter(page => page !== undefined);
    },
  },
  watch: {
    currencyCode: function () {
      this.filterProducts();
    },
    barMinValue: function () {
      console.log(4);
      this.activePage = 1;
      this.filterProducts();
    },
    barMaxValue: function () {
      this.activePage = 1;
      this.filterProducts();
    },
  },
  created() {
    // Add class immediately when component is created, before mount
    document.body.classList.add('products-page-active');
  },
  mounted() {
    // Ensure class is on page element
    const pageEl = document.getElementById('page');
    if (pageEl) {
      pageEl.classList.add('products-page-active');
    }
    
    // Also try after next tick to be sure
    this.$nextTick(() => {
      const pageEl2 = document.getElementById('page');
      if (pageEl2) {
        pageEl2.classList.add('products-page-active');
      }
    });
    
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.getCategories();
    axios
      .get("items")
      .then((res) => {
        this.productList = res.data;
        this.totalProducts = res.data.meta.total;
        this.filterProducts();
      })
      .catch((res) => {
        if (res.response.status === 401) {
          this.$parent.openSignInModal();
        }
      });
  },
  beforeDestroy() {
    // Remove class when leaving the page
    document.body.classList.remove('products-page-active');
    const pageEl = document.getElementById('page');
    if (pageEl) {
      pageEl.classList.remove('products-page-active');
    }
  },
  methods: {
    getSocialIcon(link) {
      if (!link) return '';
      const linkLower = link.toLowerCase();
      
      if (linkLower.includes('facebook') || linkLower.includes('fb')) {
        return this.acebookIcon;
      }
      if (linkLower.includes('instagram')) {
        return this.instagramIcon;
      }
      if (linkLower.includes('steam')) {
        return this.steamIcon;
      }
      return this.acebookIcon;
    },
    isFacebookLink(link) {
      return link && (link.toLowerCase().includes('facebook') || link.toLowerCase().includes('fb'));
    },
    getCategoryName(item) {
      if (!item) return '';
      
      // Если категория - строка (приоритет для нового API)
      if (item.category && typeof item.category === 'string') {
        return item.category.toUpperCase();
      }
      
      // Если категория - объект с name или text
      if (item.category && typeof item.category === 'object') {
        if (item.category.name) return item.category.name.toUpperCase();
        if (item.category.text) return item.category.text.toUpperCase();
      }
      
      // Если есть category_id, ищем в списке категорий
      if (item.category_id && this.categories && this.categories.length) {
        const category = this.categories.find(cat => cat.id === item.category_id);
        if (category) {
          return (category.text || category.name || '').toUpperCase();
        }
      }
      
      // Проверяем другие возможные варианты полей
      if (item.categoryId && this.categories && this.categories.length) {
        const category = this.categories.find(cat => cat.id === item.categoryId);
        if (category) {
          return (category.text || category.name || '').toUpperCase();
        }
      }
      
      // Проверяем массив категорий (берем первую)
      if (item.categories && Array.isArray(item.categories) && item.categories.length > 0) {
        const firstCategory = item.categories[0];
        if (typeof firstCategory === 'string') return firstCategory.toUpperCase();
        if (firstCategory.name) return firstCategory.name.toUpperCase();
        if (firstCategory.text) return firstCategory.text.toUpperCase();
        if (firstCategory.id && this.categories && this.categories.length) {
          const foundCategory = this.categories.find(cat => cat.id === firstCategory.id);
          if (foundCategory) {
            return (foundCategory.text || foundCategory.name || '').toUpperCase();
          }
        }
      }
      
      return '';
    },
    checkActiveCategory() {
      setTimeout(() => {
        let newVal = this.activeCategory;
        console.log(newVal);
        if (newVal.length > 1 && newVal[0].text === "All") {
          let newArr = newVal.filter((obj) => obj.text !== "All");
          this.activeCategory = newArr;
        } else if (
          newVal.length > 1 &&
          newVal[0].text !== "All" &&
          newVal.some((obj) => obj.text === "All")
        ) {
          let newArr = newVal.filter((obj) => obj.text === "All");
          this.activeCategory = newArr;
        } else if (newVal.length == 1 && newVal[0].text === "All") {
          this.activeCategory = [{ id: 0, text: "All" }];
        }
        this.filterProducts();
      }, 300);
    },
    reset() {
      this.activeCategory = [{ id: 0, text: "All" }];
      this.searchedProductText = "";
      this.changePage(1);

      window.scrollTo(0, 0);
    },
    getCategories() {
      axios
        .get("categories")
        .then((res) => {
          this.categories = res.data.payload.map(({ id, name, ...rest }) => ({
            id,
            text: name,
            ...rest,
          }));
          this.categories.unshift({ id: 0, text: "All" });
        })
        .catch((res) => {
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
    selectSort(event) {
      this.sort = event.id;
      this.filterProducts();
    },
    goToProduct(item) {
      this.$parent.goToProduct(item);
    },
    changePage(page) {
      this.activePage = page;
      this.filterProducts();
    },
    searchSubmit() {
      this.filterProducts();
    },
    filterProducts() {
      let addPrice =
        "&price_from=" + this.barMinValue + "&price_till=" + this.barMaxValue;
      let addSort = "sort=" + this.sort;
      let addPage = "&page=" + this.activePage;
      let addSearch = this.searchedProductText
        ? "&filter[name]=" + this.searchedProductText
        : "";
      let addcCategory;
      if (
        (this.activeCategory.length == 1 && this.activeCategory[0].id == 0) ||
        this.activeCategory == ""
      ) {
        addcCategory = "";
      } else {
        let newArr = this.activeCategory.map((item) => item.id);

        addcCategory = "&filter[category]=" + newArr;
      }
      this.$http
        .get(
          "items?" +
            addSort +
            addPage +
            addSearch +
            addPrice +
            addcCategory +
            "&per_page=9"
        )
        .then((res) => {
          this.productList = res.data;
          this.totalProducts = res.data.meta.total;
        })
        .catch(() => {});
    },
    openProductModal(product) {
      this.$emit("openProductModal", product);
    },
  },
};
</script>
